var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-text-blue-700 tw-flex tw-justify-between tw-float-right",staticStyle:{"min-width":"100px"}},[_c('b',[_vm._v(_vm._s(_vm.displaySymbol()))]),_c('b',[_vm._v(_vm._s(_vm.displayAmount()))])])}
var staticRenderFns = []

export { render, staticRenderFns }